<template>
  <div class="nx-image" :style="{'max-width':width,'max-height': height,borderRadius,overflow: 'hidden',lineHeight:0}">
    <van-image
      v-if="type==='image'"
      :width="width"
      :height="height"
      show-loading
      show-error
      :fit="fit"
      alt="加载失败"
      :src="srcFormat(src)||''"
      :round="round"
      @load="$emit('load')"
    >
      <template v-slot:error>
        <slot name="error"></slot>
      </template>
      <van-loading slot="loading" type="spinner" size="20" vertical></van-loading>
    </van-image>
    <video v-if="type==='video'" class="nx-video" :style="{width,height}" :src="src" controls></video>
    <div v-if="innerText" class="inner-text">
      {{ innerText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NxImage',
  props: {
    innerText: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: '100%',
    },
    src: {
      type: String,
      default: '',
    },
    borderRadius: {
      type: String,
      default: '16rpx',
    },
    fit: {
      type: String,
      default: 'cover',
    },
    type: {
      type: String,
      default: 'image',
    },
    round: {
      type: Boolean,
      default: false,
    },
    isOss: {
      type: Boolean,
      default: true,
    },
    // 默认图片格式为png，需要压缩图片可以传jpeg
    format: {
      type: String,
      default: 'png',
    },
  },
  data() {
    return {

    };
  },
  methods: {
    // 针对oss转换存储在OSS内原图的格式转换为png
    srcFormat(src) {
      if (src && (src.includes('http://') || src.includes('https://')) && this.isOss) {
        return `${src}?x-oss-process=image/format,${this.format}`;
      }
      else {
        return src;
      }
    },
  },
};
</script>

<style lang="scss">
.nx-image{
  position: relative;
  .inner-text{
    position: absolute;
    bottom: 12px;
    right: 12px;
    font-size: 28px;
    line-height: 28px;
    color: #fff;
  }
}
.nx-video{
  border-radius: 8px;
  // &::-webkit-media-controls-current-time-display,
  // &::-webkit-media-controls-time-remaining-display,
  // &::-webkit-media-controls-volume-slider-container,
  // &::-webkit-media-controls-volume-slider,
  // &::-webkit-media-controls-mute-button,
  // &::-webkit-media-controls-timeline,
  // &::-webkit-media-controls-timeline-container,
  // &::-webkit-media-controls-time-remaining-display,
  // &::-webkit-media-controls-seek-back-button,
  // &::-webkit-media-controls-seek-forward-button,
  // &::-webkit-media-controls-fullscreen-button,
  // &::-webkit-media-controls-rewind-button,
  // &::-webkit-media-controls-return-to-realtime-button,
  // &::-webkit-media-controls-toggle-closed-captions-button,
  // &::-webkit-media-controls-overflow-button,
  // &::-webkit-media-controls-overlay-enclosure
  // {
  //   display: none;
  // }
  // &::-webkit-media-controls-play-button{
  //   display: block;
  // }
}
</style>
